import React from "react";
import { useQuery } from "react-apollo-hooks";
import { HELP_CONFIG_QUERY } from "../../Queries";
import InitPresenter from "./Presenter/Init";
import Container from "./Container";

export default () => {
  const { data, loading } = useQuery(HELP_CONFIG_QUERY);

  if (loading) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  if (!loading && data.AdminHelpConfig) {
    return (
      <>
        <Container config={data}></Container>
      </>
    );
  }

  if (!loading && !data.AdminHelpConfig) {
    return (
      <>
        <InitPresenter></InitPresenter>
      </>
    );
  }
};
